import { ACTIONS } from 'workflow/constants/sentBoxV4';

const initialState = {
    tasks: [],
    sentTasksFetching: true,
};

const sentBoxV4Reducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.SET_SENT_TASKS: {
            const sentTasks = action.payload || [];
            return {
                ...state,
                sentTasks,
            };
        }
        case ACTIONS.SET_SENT_TASKS_COUNT: {
            const sentTasksCount = action.payload || [];
            return {
                ...state,
                sentTasksCount,
            };
        }
        case ACTIONS.SET_SENT_TASKS_STUDY_BINDER_NAMES: {
            const sentTasksStudyBinderNames = action.payload || [];
            return {
                ...state,
                sentTasksStudyBinderNames,
            };
        }
        case ACTIONS.SET_SENT_TASKS_FETCHING: {
            return {
                ...state,
                sentTasksFetching: !!action.payload
            };
        }
        default: {
            return state;
        }
    }
};

export { initialState };
export default sentBoxV4Reducer;
